import { MQ, type BreakpointName } from "../styles/breakpoints";
import { useMediaQuery } from "./useMediaQuery";

/**
 * Returns the active breakpoint name based on the current viewport.
 *
 * Defaults to `"desktop"` on first render in SSR or jsdom-style
 * environments (where matchMedia may be absent) — the assumption is that
 * desktop is the safe layout to render before the real viewport size is
 * known, since responsive primitives degrade additively from there.
 */
export function useBreakpoint(): BreakpointName {
  const isPhone = useMediaQuery(MQ.phone);
  const isTablet = useMediaQuery(MQ.tablet);
  if (isPhone) return "phone";
  if (isTablet) return "tablet";
  return "desktop";
}
